/* Quantity feedback uses Shopify's response; it never invents a stock/limit value. */
window.hederaTranslateCartError = function (payload, context = {}) {
  const strings = window.cartStrings;
  const flatten = (value) => {
    if (typeof value === 'string') return value.trim();
    if (Array.isArray(value)) return value.map(flatten).filter(Boolean).join(' ');
    if (value && typeof value === 'object') return Object.values(value).map(flatten).filter(Boolean).join(' ');
    return '';
  };
  const raw = typeof payload === 'object' && payload !== null
    ? [flatten(payload.description), flatten(payload.errors), flatten(payload.message)].filter(Boolean).join(' ')
    : flatten(payload);
  const message = raw.toLowerCase().replace(/[٠-٩]/g, (digit) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)));
  const partial = message.match(/only\s+(\d+)\s+(?:items?|units?).*(?:added)/i) ||
    message.match(/(?:تمت|تم)\s+إضافة\s+(\d+).*?فقط/) ||
    message.match(/(?:تمت|تم)\s+إضافة\s+(\d+)\s+فقط/);
  if (partial) return strings.partialAdd.replace('[quantity]', partial[1]);
  if (/sold out|نفد المخزون|نفدت الكمية|غير متوفر في المخزون/.test(message)) return strings.soldOutError;
  if (/not enough|insufficient|available stock|inventory|لا يتوفر مخزون|المخزون غير كاف/.test(message)) return strings.insufficientStock;
  if (/per.order limit|add.to.cart limit|maximum.*per.order|الحد.*(?:للطلب|في الطلب)/.test(message)) return strings.maxQuantityInCart;
  if (/maximum quantity|can't add more|cannot add more|only add|due to availability|الكمية القصوى|بسبب التوفر|لا يمكنك إضافة|يمكنك فقط إضافة/.test(message)) return strings.quantityRejected;
  if (/not available|unavailable|غير متاح/.test(message)) return strings.unavailableError;
  // Shopify change.js can reply with errors alone or a bare 422. Do not label it
  // a temporary network failure or claim a particular stock/merchant limit.
  const status = Number(context.status || (payload && payload.status));
  if (status === 422 && (!raw || /cart error|unprocessable|خطأ.*السلة/.test(message))) return strings.quantityRejected;
  return raw || strings.error;
};

// A rejected add can still add the available portion. Read actual cart + sections
// without retrying the mutation. Section Rendering supports at most 5 per request.
window.hederaRefreshCart = async function (surfaces) {
  const targets = surfaces.filter(Boolean);
  const ids = [...new Set(targets.flatMap((target) => target.getSectionsToRender().map((section) => section.section || section.id)))];
  const root = window.Shopify?.routes?.root || '/';
  const batches = [];
  for (let offset = 0; offset < ids.length; offset += 5) batches.push(ids.slice(offset, offset + 5));
  const read = async (url) => {
    const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(window.cartStrings.error);
    return response.json();
  };
  const [cart, ...sections] = await Promise.all([
    read(`${root}cart.js`),
    ...batches.map((batch) => {
      const url = new URL(window.location.href);
      url.searchParams.delete('section_id');
      url.searchParams.set('sections', batch.join(','));
      return read(url.toString());
    }),
  ]);
  cart.sections = Object.assign({}, ...sections);
  if (ids.some((id) => typeof cart.sections[id] !== 'string' || !cart.sections[id])) throw new Error(window.cartStrings.error);
  targets.forEach((target) => target.renderContents(cart));
  return cart;
};
